import { FormattedMessage, useIntl } from 'react-intl'
import { useHistory, useParams } from 'react-router-dom'

import { GLOBAL_ROUTE_PATHS } from 'Router/Router.constants'

import { Card, CardBody, TertiaryButton } from 'Components/_theme'
import { Icon } from 'Components/Icon/Icon'

import { PORTAL_CONTENT_MODEL } from 'Constants/portalContentModel'

import { composePath } from 'Portal/src/utilities/composePath/composePath.util'

import { StatisticCardChart } from '../StatisticCardChart/StatisticCardChart'
import { getLineColor } from '../StatisticCardChart/StatisticCardChart.util'
import { DashboardStatisticCardProps } from './DashboardStatisticCard.types'
import { getProgressIcon } from './DashboardStatisticCard.util'

export const DashboardStatisticCard = (props: DashboardStatisticCardProps) => {
  const intl = useIntl()
  const { count, contentType, data, labels, progress } = props
  const history = useHistory()
  const { organisationId } = useParams<{
    organisationId?: string
  }>()

  const {
    icon,
    path: modelPath,
    translationId,
  } = PORTAL_CONTENT_MODEL[contentType]

  const handleButtonClick = () => {
    history.push(
      composePath({
        params: {
          organisationId,
        },
        path: `${GLOBAL_ROUTE_PATHS.organisation.dashboard}/${modelPath}`,
      }),
    )
  }

  return (
    <Card className="DashboardStatisticCard">
      <CardBody>
        <div className="d-flex">
          <div className="mb-1">
            <p className="DashboardStatisticCard-title mb-1">
              <FormattedMessage id={translationId} />
            </p>

            <span className="h4">{count}</span>
          </div>

          <div className="ms-auto d-flex align-items-center">
            <TertiaryButton
              aria-label={intl.formatMessage({
                id: translationId,
              })}
              asIcon={icon}
              onClick={handleButtonClick}
            />
          </div>
        </div>

        <div className="d-flex align-items-center mb-1">
          <Icon
            className="me-2"
            color={getLineColor(progress)}
            icon={getProgressIcon(progress)}
            size={16}
          />

          <FormattedMessage
            id="DashboardStatisticCard_this_month"
            values={{ percent: progress }}
          />
        </div>

        {/* TODO: Replace mock data with backend data */}
        <StatisticCardChart
          data={data}
          label={translationId}
          labels={labels}
          progress={progress}
        />
      </CardBody>
    </Card>
  )
}
